import {IEventHubParams} from './types'

import {WebStat} from '@miro-site/stats'

export const initEventHub = (params: IEventHubParams): void => {
  const handler = WebStat.createStatHandler({
    apiHost: params.apiHost,
    library: 'miro-site/analytics',
    version: '0.0.1',
    addCommonStatParams: params => ({
      ...params,
    }),
    sendError: (err, extra) => console.error(err, extra),
  })

  // Expose global methods to use in GTM
  window.analytics = {
    identify: (id: string) => {
      WebStat.identify(handler, params.apiKey, {id, name: '', email: ''})
    },
    page: () => {
      WebStat.page(handler, params.apiKey)
    },
    track: (eventName, properties) => {
      let cleanProps

      // sometimes properties are passed as strings
      if (typeof properties === 'string') {
        const trimmedStringProp = properties.trim()
        if (trimmedStringProp.length > 0) {
          cleanProps = {[trimmedStringProp]: trimmedStringProp}
        }
      } else {
        cleanProps = properties
      }

      WebStat.track(handler, params.apiKey, eventName, cleanProps)
    },
  }
}
